import type { ReactElement } from "react";

import { FlexColumn, IconButton } from "@similarweb/ui-components";

import { translate } from "app/filters/i18nFilter";
import GrandAccessBanner from "app/pages/sales-intelligence/common-components/GrandAccessBanner/GrandAccessBanner";
import { SelectionDropdownFooter } from "app/pages/sales-intelligence/common-components/table-actions-panel";
import { NT_PURCHASE_PAGE_LINK } from "app/pages/sales-intelligence/constants/common";

import { StyledGradAccessWrapper } from "./styles";

interface IProps {
    isContactsReadonly: boolean;
    remainingRevealQuota: number;
}

const RevealDropdownQuotaFooter = ({ isContactsReadonly, remainingRevealQuota }: IProps): ReactElement => {
    return (
        <FlexColumn>
            {isContactsReadonly ? (
                <StyledGradAccessWrapper>
                    <GrandAccessBanner
                        title={translate("si.contacts.reveal.more_contacts.title")}
                        description={translate("si.contacts.reveal.more_contacts.description")}
                        button={
                            <IconButton
                                type={"trial"}
                                onClick={() => window.open(NT_PURCHASE_PAGE_LINK)}
                                iconName={"sparkles"}
                            >
                                {translate("si.common.upgrade_now")}
                            </IconButton>
                        }
                    />
                </StyledGradAccessWrapper>
            ) : (
                <SelectionDropdownFooter
                    numberOfRemainingItems={remainingRevealQuota}
                    label={translate("si.advanced_search.contacts_search.action.reveal.remaining_quota")}
                />
            )}
        </FlexColumn>
    );
};

export default RevealDropdownQuotaFooter;
